import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import classes from './Tooltip.module.scss';
import { TooltipArrowIcon } from '@icons';
import { useWindowSize } from 'src/hooks/useWindowSize';
import classNames from 'classnames';
const Tooltip = ({ text, children, className, position }) => {
    const wrapperRef = useRef(null);
    const contentRef = useRef(null);
    const { width, height } = useWindowSize();
    const [visibility, setVisibility] = useState('hidden');
    const setPosition = () => {
        setVisibility('visible');
    };
    const setHidden = () => {
        setVisibility('hidden');
    };
    useEffect(() => {
        // проверка visibility при изменении размеров окна
        // нужна для того, чтобы не вычислялись позиции для всех скрытых тултипов
        visibility === 'visible' && setPosition();
    }, [width, height]);
    return (_jsxs("div", { ref: wrapperRef, className: classNames(classes.wrapper, className, classes[position]), onMouseEnter: setPosition, onMouseLeave: setHidden, onTouchStart: setPosition, onTouchEnd: setHidden, "aria-hidden": visibility === 'hidden', children: [children, _jsxs("div", { ref: contentRef, className: classes.content, children: [_jsx(TooltipArrowIcon, { containerClasses: classes.arrow }), _jsx("small", { children: text })] })] }));
};
export default Tooltip;
